<template>
	<div class="cont_box">
		<div class="gall_box bai_box">
			<div class="gall_mbx">
				<el-breadcrumb separator=">">
					<el-breadcrumb-item>当前位置</el-breadcrumb-item>
					<el-breadcrumb-item>
						<span @click="tw_btn">图来图往</span>
					</el-breadcrumb-item>
					<el-breadcrumb-item>我要上传</el-breadcrumb-item>
				</el-breadcrumb>
			</div>
			<div class="gall_boxs">
				<div class="gall_is gall_bzx">
					<label for="">备注信息</label>
					<div class="gall_input">
						<textarea v-model="param.remark" cols="30" rows="10" placeholder="在此填写备注信息......"></textarea>
					</div>
				</div>
				<div class="gall_is gall_fs">
					<div class="gall_bzx_item">
						<label for="">拍摄者</label>
						<div class="gall_input">
							<input name="" v-model="param.shoter" id="" cols="30" rows="10" placeholder="请填写拍摄者姓名"></input>
						</div>
					</div>
					<div class="gall_bzx_item">
						<label for="">联系方式</label>
						<div class="gall_input">
							<input name="" id="" v-model="param.concat" cols="30" rows="10" placeholder="请填写联系方式"></input>
						</div>
					</div>
				</div>
				<div class="gall_is gall_up">
					<label for="">上传照片</label>
					<div class="gall_input">
						<el-upload class="upload-demo" ref="upload" :action="api.urls+'/front/gallery/pic/upload'" :on-change="imageChange"
						 :on-preview="handlePreview" :http-request="uploadFile" :auto-upload="false" :before-remove="beforeRemove"
						 multiple :on-exceed="handleExceed" :file-list="fileList">
							<el-button size="small">
								<img src="../../assets/image/pic_tltw_sczp@2x.png" alt="" class="img">
							</el-button>
							<div slot="tip" class="el-upload__tip">
								<span>* </span>可上传图片格式：jpg、png及压缩包形式
							</div>
						</el-upload>
					</div>
				</div>
				<div class="gall_is gall_sy">
					<label for="">选择水印</label>
					<div class="gall_input">
						<div class="gall_sy_itme" @click="param.watermarkType='AUTHOR'">
							<img src="../../assets/image/pic_tltw_pszsy_normal@2x.png" v-show="param.watermarkType!=='AUTHOR'" alt="" class="w_img">
							<img src="../../assets/image/pic_tltw_pszsy_selected@2x.png" v-show="param.watermarkType==='AUTHOR'" alt=""
							 class="x_img">
							<p :class="{active: param.watermarkType==='AUTHOR'}">
								显示拍摄者
							</p>
						</div>
						<div class="gall_sy_itme" @click="param.watermarkType='CONCAT'">
							<img src="../../assets/image/pic_tltw_lxfsy_normal@2x.png" v-show="param.watermarkType!=='CONCAT'" alt="" class="w_img">
							<img src="../../assets/image/pic_tltw_lxfsy_selected@2x.png" v-show="param.watermarkType==='CONCAT'" alt=""
							 class="x_img">
							<p :class="{active: param.watermarkType==='CONCAT'}">
								显示联系方式
							</p>
						</div>
						<div class="gall_sy_itme" @click="param.watermarkType='WX_CODE'">
							<img src="../../assets/image/pic_tltw_ewmsy_normal@2x.png" v-show="param.watermarkType!=='WX_CODE'" alt="" class="w_img">
							<img src="../../assets/image/pic_tltw_ewmsy_selected@2x.png" v-show="param.watermarkType==='WX_CODE'" alt=""
							 class="x_img">
							<p :class="{active: param.watermarkType==='WX_CODE'}">
								显示微信二维码
							</p>
						</div>
						<div class="gall_sy_itme" @click="param.watermarkType='NONE'">
							<img src="../../assets/image/pic_tltw_bxssy_normal@2x.png" v-show="param.watermarkType!=='NONE'" alt="" class="w_img">
							<img src="../../assets/image/pic_tltw_bxssy_selected@2x.png" v-show="param.watermarkType==='NONE'" alt="" class="x_img">
							<p :class="{active: param.watermarkType==='NONE'}">
								仅显示网站logo
							</p>
						</div>
					</div>
				</div>
				<!-- 	<div class="gall_is gall_sy">
				    <label for="">网站logo</label>
				    <div class="gall_input">
				        <div class="gall_sy_itme" @click="param.watermarkType='AUTHOR'">
				            <img src="../../assets/image/pic_wzlogo_green_nomal@2x.png"
				                 v-show="param.watermarkType!=='AUTHOR'" alt="" class="w_img">
				            <img src="../../assets/image/pic_wzlogo_green_selected@2x.png"
				                 v-show="param.watermarkType==='AUTHOR'" alt="" class="x_img">
				        </div>
				        <div class="gall_sy_itme" @click="param.watermarkType='CONCAT'">
				            <img src="../../assets/image/pic_wzlogo_oran_normal@2x.png"
				                 v-show="param.watermarkType!=='CONCAT'" alt="" class="w_img">
				            <img src="../../assets/image/pic_wzlogo_oran_selected@2x.png"
				                 v-show="param.watermarkType==='CONCAT'" alt="" class="x_img">
				        </div>
				        <div class="gall_sy_itme" @click="param.watermarkType='WX_CODE'">
				            <img src="../../assets/image/pic_wzlogo_white_normal@2x.png"
				                 v-show="param.watermarkType!=='WX_CODE'" alt="" class="w_img">
				            <img src="../../assets/image/pic_wzlogo_white_selected@2x.png"
				                 v-show="param.watermarkType==='WX_CODE'" alt=""
				                 class="x_img">
				        </div>
						<div slot="tip" class="el-upload__tips">
						    <span>* </span>默认logo颜色为绿色
						</div>
				    </div>
				</div> -->
				<div class="gall_is gall_up">
					<label for="">二维码</label>
					<div class="gall_input">
						<el-upload ref="uploads" class="upload-demo" name="files" :action="api.urls+'/file/upload'" :on-preview="handlePreview"
						 :on-remove="handleRemove" :on-success="succ_btn" :before-remove="beforeRemove" multiple :limit="1" :on-exceed="handleExceed">
							<el-button size="small">
								<img src="../../assets/image/pic_tltw_sczp@2x.png" alt="" class="img">
							</el-button>
							<div slot="tip" class="el-upload__tip">
								<span>* </span>选择显示微信二维码水印时，须上传您的二维码图片
							</div>
						</el-upload>
					</div>
				</div>
				<div class="gall_is gall_box">
					<div class="gall_btns" @click="up_btn">
						确认上传
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import headers from '@/components/header';
	import foot from '@/components/foot';
	import api from '../../api/require.js';

	export default {
		name: "UserDialong",
		data() {
			return {
				not_flag: true,
				tab_index: 'tltw',
				currentPage3: 5,
				sy_index: 1,
				param: {
					remark: '', // 备注信息
					concat: '', //联系方式
					shoter: '', //拍摄者
					watermarkType: 'NONE', //水印类型
					qrCodeId: '', //二维码id
					zipId: '', // 上传图片id
				},
				fileList: [],
				fileData: '',
				api,
			}
		},
		mounted() {},
		methods: {
			//选择图片后做图片格式限制（手动上传图片时，before-upload钩子无效，使用此方法替代）
			imageChange(file, fileList) {
				const isImage = file.raw.type == 'image/png' || file.raw.type == 'image/jpg' || file.raw.type == 'image/jpeg';
				const isLt5M = file.size < 1024 * 1024 * 5;
				if (!isLt5M) {
					this.$message.error('上传图片大小不能超过 5MB!');
				}

				if (isImage && isLt5M) {
					this.fileList = file.raw || null;
				} else {
					fileList.splice(-1, 1);
				}
			},
			tw_btn() {
				this.$router.push({
					path: 'chart_index'
				})
			},
			succ_btn(res) {
				if (this.param.watermarkType == 'WX_CODE') {
					this.param.qrCodeId = res.data[0].fileId
				}
			},
			uploadFile(file) {
				this.fileData.append('files', file.file);
			},
			up_btn() {

				if (!this.param.shoter) {
					this.$message({
						message: '拍摄者不能为空哦',
						type: 'warning'
					});
					return
				}
				if (!this.param.concat) {
					this.$message({
						message: '联系方式不能为空哦',
						type: 'warning'
					});
					return
				}
				// if (this.param.concat.length != 11) {
				//     this.$message({
				//         message: '请输入正确的联系方式',
				//         type: 'warning'
				//     });
				//     return
				// }
				if (!this.$refs.upload.uploadFiles.length) {
					this.$message({
						message: '请上传最少一张图片',
						type: 'warning'
					});
					return
				}
				if (!this.param.watermarkType) {
					this.$message({
						message: '请选择水印',
						type: 'warning'
					});
					return
				}
				if (this.param.watermarkType == 'WX_CODE' && this.param.qrCodeId == '') {
					this.$message({
						message: '请上传微信二维码',
						type: 'warning'
					});
					return
				}
				this.fileData = new FormData(); // new formData对象
				this.$refs.upload.submit(); // 提交调用uploadFile函数
				this.$http.up('/front/gallery/pic/upload', this.fileData).then((response) => {
					this.param.zipId = response.data.id
					console.log(this.param)
					this.$http.submit('/front/gallery/pic', JSON.stringify(this.param)).then(red => {
						console.log(red)
						this.$message({
							message: '上传成功',
							type: 'success'
						});
						this.$refs.upload.clearFiles();
						this.$refs.uploads.clearFiles();
						this.param = {
							remark: '', // 备注信息
							concat: '', //联系方式
							shoter: '', //拍摄者
							watermarkType: '', //水印类型
							qrCodeId: '', //二维码id
							zipId: '', // 上传图片id
						}
					})
				});
			},
			submitUpload() {
				console.log(11)
			},
			handleRemove(file, fileList) {
				this.param.qrCodeId = ''
			},
			handlePreview(file) {
				console.log(file);
			},
			handleExceed(files, fileList) {
				this.$message.warning(`当前限制只能上传 1 张图片`);
			},
			beforeRemove(file, fileList) {
				return this.$confirm(`确定移除 ${file.name}？`);
			},
			stor_btn() {
				this.$router.push({
					path: 'story_dec'
				})
			},
			slt_btn() {
				this.$router.push({
					path: 'gallery_indexTw'
				})
			},
			handleSizeChange(val) {
				console.log(`每页 ${val} 条`);
			},
			handleCurrentChange(val) {
				console.log(`当前页: ${val}`);
			}
		},
		components: {
			headers,
			foot,
		}
	}
</script>

<style lang="less" scoped>
	.bai_box{
		padding: 0 23px;
		box-sizing: border-box;
	}
	/deep/ .el-button--small {
		padding: 0;
		border: none;
		border-color: #fff !important;
		color: #fff !important;
		background-color: #fff !important;

		.img {
			width: 113px;
			height: 112px;
		}
	}

	/deep/ .el-upload__tips {
		margin-top: 0;
		display: inline-block;
		margin-left: 14px;
		font-size: 13px;
		position: relative;
		bottom: -100px;
		color: #606266;

		span {
			color: #FF0000;
		}
	}

	/deep/ .el-upload__tip {
		margin-top: 0;
		width: calc(100% - 127px);
		display: inline-block;
		margin-left: 14px;
		font-size: 13px;
		position: relative;
		top: -7px;

		span {
			color: #FF0000;
		}
	}

	/deep/ .upload-demo {
		/deep/ .el-upload-list {
			position: relative;
			left: 0;
			width: 338px;
			background: #F5F5F5;

			/deep/ .el-icon-document {
				width: 23px;
				position: relative;

				&::before {
					position: absolute;
					top: -15px;
					left: 0;
					content: '';
					width: 23px;
					height: 19px;
					background: url(../../assets/image/icon_tltw_sczp@2x.png) no-repeat;
					background-size: 100% 100%;
					background-position: center;
				}
			}
		}
	}

	.scan_code {
		float: right;
		width: 88px;
		text-align: center;
		margin: 19px 0 0 26px;
		position: relative;

		.wx_qr_code {
			width: 88px;
			height: 88px;
		}

		h5 {
			text-decoration: none;
			font-weight: normal;
			line-height: 1.4;
			font-size: 12px;
			position: absolute;
			left: 0;
			top: 90px;
			width: 88px;

		}
	}

	.gall_box {
		width: 870px;
		margin: 0 auto;

		.gall_mbx {
			margin: 0 0 60px;
			padding-top: 38px;

			span {
				font-size: 13px;
				cursor: pointer;
			}
		}

		.gall_boxs {
			.gall_is {
				margin-bottom: 23px;
				display: flex;
				align-items: center;

			}

			.gall_box {
				justify-content: flex-end;
				width: 100%;

				.gall_btns {
					width: 195px;
					height: 45px;
					background-color: #22AB67;
					color: #fff;
					font-size: 18px;
					border-radius: 22px;
					text-align: center;
					line-height: 45px;
					margin-bottom: 36px;
					cursor: pointer;
				}
			}

			label {
				width: 65px;
				font-size: 13px;
				color: #333333;
			}

			.gall_up {
				align-items: flex-start;

				label {
					position: relative;
					top: 56px;
					transform: translateY(-50%);
				}

				.gall_input {
					flex: 1;
				}
			}

			.gall_bzx {
				height: 125px;

				.gall_input {
					flex: 1;
					height: 100%;
					background: #F5F5F5;
					border-radius: 8px;

					textarea {
						width: 100%;
						height: 100%;
						padding: 18px 19px;
						box-sizing: border-box;
						background: #F5F5F5;
						border: none;
						outline: none;
						border-radius: 8px;
						resize: none;

						&::placeholder {
							color: #B8B8B8;
						}
					}

				}
			}

			.gall_fs {
				.gall_bzx_item {
					flex: 1;
					display: flex;
					align-items: center;

					&:first-child {
						margin-right: 44px;
					}

					.gall_input {
						flex: 1;

						input {
							height: 52px;
							width: 100%;
							border-radius: 8px;
							background: #F5F5F5;
							font-size: 13px;
							padding: 0 19px;
							box-sizing: border-box;
							outline: none;

							&::placeholder {
								color: #B8B8B8;
							}
						}
					}
				}
			}

			.gall_sy {
				align-items: flex-start;

				label {
					position: relative;
					top: 60px;
					transform: translateY(-50%);
				}

				.gall_input {
					display: flex;
				}

				.gall_sy_itme {
					width: 119px;
					margin-right: 20px;
					cursor: pointer;

					img {
						width: 100%;
						height: 120px;
					}

					p {
						padding: 11px 0;
						color: #4A4A4A;
						font-size: 13px;
						text-align: center;
					}

					.active {
						color: #22AB67;
					}
				}
			}
		}
	}
</style>
